import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {GenericModalModule} from '../modal/generic-modal.module';
import {FfmpegDefinitionComponent} from './ffmpegDefinition.component';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        GenericModalModule
    ],
    declarations: [FfmpegDefinitionComponent
    ],
    exports: [
        FfmpegDefinitionComponent
    ],
    providers: []
})

export class FfmpegDefinitionModule {
}
